import React, {useState} from 'react';
import Proptypes from 'prop-types';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
function ClearableButtonAdornment({onClick}) {
   return (
      <InputAdornment position="start">
         <Tooltip title="Limpiar seleccion">
            <IconButton onClick={onClick} aria-label="delete" size="small">
               <HighlightOffIcon />
            </IconButton>
         </Tooltip>
      </InputAdornment>
   );
}
function SelectTooltip({
   showTooltip,
   onChange,
   name,
   clearValue,
   noDataValue,
   id,
   loading,
   loadingLabel,
   noDataLabel,
   data,
   value,
   genItemKey,
   genItemValue,
   genItemLabel,
   lastItem,
   isClearable,
   ...other
}) {
   const [tooltipTitle, settooltipTitle] = useState('');
   function handleOnClearValue() {
      onChange({target: {name, value: clearValue}});
      settooltipTitle('');
   }
   function handleOnValueChange(e, itemMenu) {
      //const itemMenu = [...itemMenu];
      if (itemMenu && itemMenu.props && itemMenu.props['data-item']) {
         const item = JSON.parse(itemMenu.props['data-item']);
         e.target.item = item;
         settooltipTitle(genItemLabel(item));
      }
      onChange(e);
   }
   if (showTooltip && tooltipTitle) {
      return (
         <Tooltip title={tooltipTitle}>
            <Select
               {...other}
               value={value}
               onChange={handleOnValueChange}
               inputProps={{
                  name,
                  id
               }}
               startAdornment={
                  isClearable ? (
                     <ClearableButtonAdornment onClick={handleOnClearValue} />
                  ) : undefined
               }
            >
               {loading ? (
                  <MenuItem key={0} value={noDataValue}>
                     {loadingLabel}
                  </MenuItem>
               ) : data === undefined || data.length === 0 ? (
                  <MenuItem key={0} value={noDataValue}>
                     {noDataLabel}
                  </MenuItem>
               ) : (
                  data.map((item) => {
                     return (
                        <MenuItem
                           key={genItemKey(item)}
                           value={genItemValue(item)}
                           data-item={JSON.stringify(item)}
                        >
                           {genItemLabel(item)}
                        </MenuItem>
                     );
                  })
               )}
               {lastItem}
            </Select>
         </Tooltip>
      );
   }
   return (
      <Select
         value={value}
         onChange={handleOnValueChange}
         inputProps={{
            name,
            id
         }}
         startAdornment={
            isClearable ? <ClearableButtonAdornment onClick={handleOnClearValue} /> : undefined
         }
      >
         {loading ? (
            <MenuItem key={0} value={noDataValue}>
               {loadingLabel}
            </MenuItem>
         ) : data === undefined || data.length === 0 ? (
            <MenuItem key={0} value={noDataValue}>
               {noDataLabel}
            </MenuItem>
         ) : (
            data.map((item) => {
               return (
                  <MenuItem
                     key={genItemKey(item)}
                     value={genItemValue(item)}
                     data-item={JSON.stringify(item)}
                  >
                     {genItemLabel(item)}
                  </MenuItem>
               );
            })
         )}
         {lastItem}
      </Select>
   );
}
function SelectDS({
   label,
   id,
   name,
   value,
   onChange,
   data,
   lastItem,
   helperText,
   genItemValue,
   genItemKey,
   genItemLabel,
   noDataValue,
   noDataLabel,
   loading,
   loadingLabel,
   isClearable,
   clearValue,
   showTooltip,
   ...other
}) {
   const inputLabelId = label && id ? `${id}-label` : undefined;
   return (
      <FormControl {...other}>
         <InputLabel style={{backgroundColor: 'white'}} htmlFor={id} id={inputLabelId}>
            {label}
         </InputLabel>
         <SelectTooltip
            showTooltip={showTooltip}
            onChange={onChange}
            name={name}
            clearValue={clearValue}
            noDataValue={noDataValue}
            id={id}
            loading={loading}
            loadingLabel={loadingLabel}
            noDataLabel={noDataLabel}
            data={data}
            value={value}
            genItemKey={genItemKey}
            genItemValue={genItemValue}
            genItemLabel={genItemLabel}
            lastItem={lastItem}
            isClearable={isClearable}
         />
         <FormHelperText id={`${name}-helper-text`}>{helperText}</FormHelperText>
      </FormControl>
   );
}

SelectDS.propTypes = {
   id: Proptypes.string,
   name: Proptypes.string,
   label: Proptypes.string,
   value: Proptypes.any.isRequired,
   onChange: Proptypes.any.isRequired,
   data: Proptypes.arrayOf(Proptypes.any),
   lastItem: Proptypes.element,
   helperText: Proptypes.string,
   genItemValue: Proptypes.func,
   genItemKey: Proptypes.func,
   genItemLabel: Proptypes.func,
   noDataValue: Proptypes.any,
   noDataLabel: Proptypes.string,
   loading: Proptypes.bool,
   loadingLabel: Proptypes.string,
   isClearable: Proptypes.bool,
   clearValue: Proptypes.any,
   showTooltip: Proptypes.bool
};

SelectDS.defaultProps = {
   genItemValue: (item) => {
      return item;
   },
   genItemKey: (item) => {
      return item;
   },
   genItemLabel: (item) => {
      return item;
   },
   noDataValue: -1,
   noDataLabel: 'No hay datos para mostrar.',
   loadingLabel: 'Cargando...',
   isClearable: false,
   clearValue: '',
   showTooltip: false
};
export default SelectDS;
